export default [
    {
      path: '/rooms',
      name: 'rooms-read',
      component: () => import('@/views/room/room-list/RoomList.vue'),
      meta: {
        resource: 'Rooms',
        action: 'read',
      },
    },
    {
      path: '/rooms/create',
      name: 'rooms-create',
      component: () => import('@/views/room/room-form/RoomForm.vue'),
      meta: {
        resource: 'Rooms',
        action: 'create',
      },
    },
    {
      path: '/room/amenities',
      name: 'amenities-read',
      component: () => import('@/views/room/amenity-list/AmenityList.vue'),
      meta: {
        resource: 'Room Amenities',
        action: 'read',
      },
    },
    {
      path: '/room/amenities/create',
      name: 'amenities-create',
      component: () => import('@/views/room/amenity-list/AmenityForm.vue'),
      meta: {
        resource: 'Room Amenities',
        action: 'create',
      },
    },
    {
      path: '/room/features',
      name: 'features-read',
      component: () => import('@/views/room/feature-list/FeatureList.vue'),
      meta: {
        resource: 'Room Features',
        action: 'read',
      },
    },
    {
      path: '/room/features/create',
      name: 'features-create',
      component: () => import('@/views/room/feature-list/FeatureForm.vue'),
      meta: {
        resource: 'Room Features',
        action: 'create',
      },
    }
]